import { render, staticRenderFns } from "./passwords.vue?vue&type=template&id=47926802&scoped=true&"
import script from "./passwords.vue?vue&type=script&lang=js&"
export * from "./passwords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47926802",
  null
  
)

export default component.exports